<template>
  <div class="container-fluid" style="height: 100vh; width: 100vw">
    <div class="spinner-container" v-if="loading == 1">
      <div id="loader"></div>
    </div>
    <div class="row">
      <div
        class="col-lg-2 col-md-2"
        style="paddingLeft: 0px; paddingRight: 0px"
      >
        <Sidebar />
      </div>

      <div class="col-lg-10 col-md-10 col-12 dev animate-bottom">
        <div class="row pt-2">
          <div
            class="col-sm-1 text-left back"
            title="Back to all customers"
            @click="setPrevRoute"
          >
            <i class="fa fa-angle-double-left"></i>
          </div>
          <div class="col-sm-10 h3">Edit Device</div>
        </div>
        <div class="row border brdrad shdw mt-1" style="height: inherit; width: inherit">
          <div class="col-lg-12 listofdev border" style="overflow-y: auto">
            <div class="row mx-2 py-4">
              <div class="col-md-6 col-sm-12 my-2">
                <label class="labelClass">Device Name</label>
                <br />
                <input
                  class="form-control"
                  type="text"
                  v-model="dName"
                  placeholder="Device Name"
                />
              </div>
              <div class="col-md-3 col-sm-12 my-2">
                <label class="labelClass">Device type</label>
                <br />
                <select
                  class="custom-select form-control border"
                  v-model="devType"
                >
                  <option selected value disabled>{{ devType }}</option>
                  <option value="ii">ii</option>
                  <option value="oo">oo</option>
                  <option value="oi">oi</option>
                </select>
              </div>
              <div class="col-md-3 col-sm-12 my-2 text-center">
                <label class="labelClass">gas sensor</label>
                <br />
                <input type="checkbox" id="checkbox" v-model="gsSensr" />
              </div>

              <div class="row d-flex justify-content-around p-3 polrow">
                <div class="form-check form-check-inline p-1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="PM25"
                    value="PM25"
                    v-model="checkedPols"
                  />
                  <label class="form-check-label" for="inlineCheckbox1"
                    >PM2.5</label
                  >
                </div>
                <div class="form-check form-check-inline p-1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="inlineCheckbox2"
                    value="PM10"
                    v-model="checkedPols"
                  />
                  <label class="form-check-label" for="inlineCheckbox2"
                    >PM10</label
                  >
                </div>
                <div class="form-check form-check-inline p-1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="inlineCheckbox3"
                    value="PM1"
                    v-model="checkedPols"
                  />
                  <label class="form-check-label" for="inlineCheckbox3"
                    >PM1</label
                  >
                </div>
                <div class="form-check form-check-inline p-1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="inlineCheckbox1"
                    value="CO2"
                    v-model="checkedPols"
                  />
                  <label class="form-check-label" for="inlineCheckbox1"
                    >CO2</label
                  >
                </div>
                <div class="form-check form-check-inline p-1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="inlineCheckbox2"
                    value="SO2"
                    v-model="checkedPols"
                  />
                  <label class="form-check-label" for="inlineCheckbox2"
                    >SO2</label
                  >
                </div>
                <div class="form-check form-check-inline p-1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="inlineCheckbox3"
                    value="NO2"
                    v-model="checkedPols"
                  />
                  <label class="form-check-label" for="inlineCheckbox3"
                    >NO2</label
                  >
                </div>
                <div class="form-check form-check-inline p-1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="inlineCheckbox1"
                    value="CO"
                    v-model="checkedPols"
                  />
                  <label class="form-check-label" for="inlineCheckbox1"
                    >CO</label
                  >
                </div>
                <div class="form-check form-check-inline p-1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="inlineCheckbox2"
                    value="O3"
                    v-model="checkedPols"
                  />
                  <label class="form-check-label" for="inlineCheckbox2"
                    >O3</label
                  >
                </div>
                <div class="form-check form-check-inline p-1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="inlineCheckbox2"
                    value="TVOC"
                    v-model="checkedPols"
                  />
                  <label class="form-check-label" for="inlineCheckbox2"
                    >TVOC</label
                  >
                </div>
                <div class="form-check form-check-inline p-1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="inlineCheckbox2"
                    value="HCHO"
                    v-model="checkedPols"
                  />
                  <label class="form-check-label" for="inlineCheckbox2"
                    >HCHO</label
                  >
                </div>
                <div class="form-check form-check-inline p-1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="inlineCheckbox2"
                    value="temperature"
                    v-model="checkedPols"
                  />
                  <label class="form-check-label" for="inlineCheckbox2"
                    >Temp</label
                  >
                </div>
                <div class="form-check form-check-inline p-1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="inlineCheckbox2"
                    value="pressure"
                    v-model="checkedPols"
                  />
                  <label class="form-check-label" for="inlineCheckbox2"
                    >Pres</label
                  >
                </div>
                <div class="form-check form-check-inline p-1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="inlineCheckbox2"
                    value="humidity"
                    v-model="checkedPols"
                  />
                  <label class="form-check-label" for="inlineCheckbox2"
                    >Humid</label
                  >
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 col-sm-12">
                <label class="labelClass">Description</label>
                <br />
                <textarea
                  rows="2"
                  class="form-control"
                  type="text"
                  style="height: auto !important"
                  v-model="Description"
                  placeholder="Company Address"
                ></textarea>
              </div>
              <div class="col-md-6 col-sm-12">
                <label class="labelClass">Address</label>
                <br />
                <textarea
                  rows="2"
                  class="form-control"
                  type="text"
                  style="height: auto !important"
                  v-model="Address"
                  placeholder="Company Address"
                ></textarea>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 col-sm-12 my-2">
                <label class="labelClass">Select Comapny</label>
                <br />
                <select class="form-control inputFont" v-model="customer">
                  <option disabled selected value>Please Select</option>
                  <option v-for="(customer, key) in companies" :key="key">
                    {{ customer.name }}
                  </option>
                </select>
              </div>
              <div class="col-md-6 col-sm-12 my-2">
                <div class="row">
                  <div class="col-sm-6">
                    <label class="labelClass">city</label>
                    <input
                      class="form-control"
                      type="text"
                      v-model="city"
                      placeholder="city"
                    />
                  </div>
                  <div class="col-sm-6">
                    <label class="labelClass">state</label>
                    <input
                      class="form-control"
                      type="text"
                      v-model="state"
                      placeholder="state"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 col-sm-12 my-2">
                <label class="labelClass">Select Country</label>
                <br />
                <select class="form-control inputFont" v-model="country">
                  <option disabled selected value>Please Select</option>
                  <option v-for="(country, key) in countries" :key="key">
                    {{ country }}
                  </option>
                </select>
              </div>
              <div class="col-md-4 col-sm-8 my-2">
                <label class="labelClass">Postal Code</label>
                <br />
                <input
                  class="form-control"
                  placeholder="postal code"
                  type="number"
                  v-model="postalCode"
                />
              </div>
            </div>
            <div class="col-md-6 col-sm-12 my-2">
              <div class="row">
                <div class="col-sm-6">
                  <label class="labelClass">lat</label>
                  <input
                    class="form-control"
                    type="number"
                    v-model="lat"
                    placeholder="lat"
                  />
                </div>
                <div class="col-sm-6">
                  <label class="labelClass">long</label>
                  <input
                    class="form-control"
                    type="number"
                    v-model="lng"
                    placeholder="long"
                  />
                </div>
              </div>
            </div>
            <div class="row d-flex justify-content-center p-2">
              <button
                @click="clearHistory"
                :style="roleId != 3 ? 'display: none;' : ''"
                class="btn btn-danger mr-3"
              >
                Clear History
              </button>
              <button @click="submitForm" class="btn btn-primary">
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade bd-example-modal-lg"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
    >
      <div class="modal-dialog modal-sm">
        <div class="modal-content" style="width: 48px">
          <span class="fa fa-spinner fa-spin fa-3x"></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import _ from "underscore";
import { apiCall } from "@/utils/api";
import Sidebar from "../Sidebar";
import swtAlrt from "../../../mixins/swtalrt";
import dataJson from "../../json/countries.json";

// import _ from 'underscore';

export default {
  components: {
    Sidebar,
  },
  data() {
    return {
      roleId: parseInt(JSON.parse(localStorage.getItem("user")).roleId),
      state: "",
      city: "",
      Address: "",
      Description: "",
      lat: "",
      lng: "",
      dName: "",
      customer: "",
      companies: {},
      loading: 0,
      countries: dataJson.country,
      country: "",
      countryCode: "",
      postalCode: "",
      deviceId: "",
      devType: "",
      gsSensr: false,
      companyId: "",
      deviceData: {},
      polArr : [],
      checkedPols : []
      // routeTo : parseInt(JSON.parse(localStorage.getItem("user")).roleId) === 3 ? '/search' : '/devices'
    };
  },
  mixins: [swtAlrt],
  watch: {
    country(newVal) {
      let code = Object.keys(this.countries).find(
        (key) => this.countries[key] === newVal
      );
      this.countryCode = code;
      // console.log("newVal", newVal);
    },
    customer(newVal) {
      let company = _.filter(this.companies, (company) => {
        return company.name == newVal;
      });
      this.companyId = company[0]._id;
    },
  },
  mounted() {
    this.deviceId = this.$route.params.deviceId;
    this.getAllCustomer(this.deviceId);
  },
  methods: {
    clearHistory() {
      this.loading = 1;
      const url = `reading/delete/${this.deviceId}`;
      apiCall({ url: url, method: "delete" })
        .then((r) => {
          this.loading = 0;
          this.swalHistSuccess();
        })
        .catch((err) => {
          this.loading = 0;
          this.swalNetworkError();
          console.log("error is here", err);
        });
    },
    getInfoOfDevice(id) {
      let url = `device/info/${id}`;
      apiCall({ url: url, method: "get" })
        .then((resp) => {
          this.companyId = resp.data.companyId;
          this.dName = resp.data.name;
          this.devType = resp.data.deviceType ? resp.data.deviceType : "";
          this.gsSensr = resp.data.gasSensor ? resp.data.gasSensor : false;
          this.Address = resp.data.address;
          this.lat = resp.data.lat;
          this.lng = resp.data.lng;
          this.Description = resp.data.description;
          this.city = resp.data.city;
          this.state = resp.data.state;
          this.country = resp.data.country;
          this.countryCode = resp.data.countryCode;
          this.postalCode = resp.data.postalCode;
          this.checkedPols = resp.data.pollutants || [];
          let companyName = _.filter(this.companies, (company) => {
            return company._id == this.companyId;
          });
          this.customer = companyName[0].name;
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    setPrevRoute() {
      this.$router.go(-1);
    },
    submitForm() {
      this.loading = 1;
      let body = {
        deviceId: this.deviceId,
        device: {
          deviceType: this.devType,
          description: this.Description,
          gasSensor: this.gsSensr,
          address: this.Address,
          city: this.city,
          country: this.country,
          countryCode: this.countryCode,
          lat: this.lat,
          lng: this.lng,
          name: this.dName,
          postalCode: this.postalCode,
          state: this.state,
          companyId: this.companyId,
          pollutants : this.checkedPols
        },
      };
      let url = "device/update";
      // let url = "device/update/pollutants";
      apiCall({ url: url, data: body, method: "post" })
        .then((resp) => {
          this.loading = 0;
          this.swalDeviceSuccess();
        })
        .catch((err) => {
          this.loading = 0;
          this.swalNetworkError();
          console.log("error", err);
        });
    },
    getAllCustomer(id) {
      apiCall({ url: "company", method: "get" })
        .then((resp) => {
          this.companies = resp.data;
          this.getInfoOfDevice(id);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style>
.container-fluid {
  margin: 0px;
  padding: 0px;
}
.ubuntu-small {
  font-family: Ubuntu;
  font-weight: 200;
  font-size: 10px;
  color: rgba(59, 59, 59, 0.8);
}
.ubuntu-medium {
  font-family: Ubuntu;
  font-weight: 500;
  font-size: 14px;
  color: rgba(59, 59, 59, 0.8);
}
.dev {
  font-family: Ubuntu;
  font-weight: 200;
  color: rgba(59, 59, 59, 0.8);
  padding-left: 3.5rem !important;
  padding-right: 2.2rem !important;
}
a {
  /* color: rgba(59, 59, 59, 0.8); */
  text-decoration: none;
}
.btn:focus {
  box-shadow: none;
}
.form-control {
  color: rgba(59, 59, 59, 0.8);
  font-family: Ubuntu;
  font-weight: 200;
  font-size: 13px;
  height: 2rem !important;
}
.option:hover {
  color: #2295c8;
  background-color: transparent;
}
.form-control:focus {
  box-shadow: none;
  border: none;
}
.option:focus {
  background-color: transparent;
  border: none;
}
.form-check-input {
  margin-top: 0.7rem;
}
.listofdev {
  box-shadow: 0 0.5rem 0.5rem rgba(0, 0, 0, 0.2);
  border-top: none !important;
  padding-left: 0px;
  padding-right: 0px;
}
.srchfilter {
  border-bottom: none !important;
  /* background-color: #2295c8; */
  background-color: rgba(0, 0, 0, 0.1);
  width: 100%;
  border: 1px solid #dedede;
  padding-top: 5px;
  padding-bottom: 5px;
}
a:link {
  text-decoration: none;
}
a {
  color: rgba(59, 59, 59, 0.8);
}
a:hover {
  color: #2295c8;
}
.bd-example-modal-lg .modal-dialog {
  display: table;
  position: relative;
  margin: 0 auto;
  top: calc(50% - 24px);
}

.bd-example-modal-lg .modal-dialog .modal-content {
  background-color: transparent;
  border: none;
}

.model {
  display: block;
}

.count-row {
  font-size: 20px;
}
.back {
  cursor: pointer;
}
#loader {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 1;
  width: 150px;
  height: 150px;
  margin: -75px 0 0 -75px;
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

.spinner-container {
  position: absolute;
  width: 100%;
  height: 100%;
  background: black;
  opacity: 0.6;
  z-index: 1;
  margin: -15px;
}
.custom-control-label::before,
.custom-control-label::after {
  padding: 0.8rem;
  /* width: 2rem; */
  /* height: 2rem; */
}
.save:hover {
color : white;
}
.polrow{
  font-size: 0.85rem !important;
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Add animation to 'page content' */
.animate-bottom {
  position: relative;
  -webkit-animation-name: animatebottom;
  -webkit-animation-duration: 1s;
  animation-name: animatebottom;
  animation-duration: 1s;
}

@-webkit-keyframes animatebottom {
  from {
    bottom: -100px;
    opacity: 0;
  }
  to {
    bottom: 0px;
    opacity: 1;
  }
}

@keyframes animatebottom {
  from {
    bottom: -100px;
    opacity: 0;
  }
  to {
    bottom: 0;
    opacity: 1;
  }
}
</style>
